import React from "react";
import { useHomeV2Context } from "../context/home_v2_context";

const TestimonialComp = () => {
  const {
    testimonials,
    activeTestimonial,
    setActiveTestimonial,
    setTouchStart,
    setTouchEnd,
  } = useHomeV2Context();

  return (
    <div
      id="testimonials"
      className="w-full max-w-4xl mx-auto mb-20 pt-8 scroll-mt-20"
    >
      <h2 className="text-3xl font-bold mb-8 text-center text-pink-200 max-sm:text-2xl">
        Real Experiences
      </h2>

      <div className="bg-slate-950/70 backdrop-blur-sm border border-red-900/20 rounded-xl p-8 overflow-hidden relative">
        <div
          className="relative h-60"
          onTouchStart={(e) => setTouchStart(e.touches[0].clientX)}
          onTouchMove={(e) => setTouchEnd(e.touches[0].clientX)}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-all duration-500 flex flex-col justify-center ${
                index === activeTestimonial
                  ? "opacity-100 translate-x-0"
                  : index < activeTestimonial
                  ? "opacity-0 -translate-x-full"
                  : "opacity-0 translate-x-full"
              }`}
            >
              <p className="text-xl text-pink-300 italic mb-6 max-sm:text-base">
                "{testimonial.text}"
              </p>
              <div className="flex items-center justify-between">
                <p className="font-medium text-white max-sm:text-sm">
                  {testimonial.name}
                </p>
                <p className="text-sm text-pink-400 max-sm:text-xs">
                  {testimonial.duration}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Testimonial navigation */}
        <div className="flex items-center justify-center mt-4 relative">
          {/* Testimonial indicators */}
          <div className="flex justify-center space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === activeTestimonial
                    ? "bg-pink-500 w-4"
                    : "bg-pink-500/30"
                }`}
                onClick={() => setActiveTestimonial(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialComp;
